import { Row, Col, Card, Avatar, Typography, Space } from "antd";
import { UserOutlined } from "@ant-design/icons";
import Article from "./components/Article/Article";
import { useSelector } from "react-redux";
import { selectUser } from "AppStore/Slices/UserSlice/UserSlice";
import { ProjectsInfo } from "./components/ProjectsInfo/ProjectsInfo";
import { checkRoleAccess } from "Helpers/checkRoleAccess";
import { ROLE } from "Helpers/roles/roles";

const { Title } = Typography;

export default function MainPage() {
  const { user, roles } = useSelector(selectUser);
  return (
    <div>
      <Card
        style={{
          borderRadius: 16,
          marginBottom: 24,
        }}
      >
        <Space size={16} align="center">
          <Avatar
            size={64}
            icon={<UserOutlined />}
            src={"/img/palogo.jpg"}
            shape="square"
          />
          <div>
            <Title level={3} style={{ marginBottom: 4 }}>
              Привіт, {user.name} 👋
            </Title>
          </div>
        </Space>
      </Card>

      <Row gutter={[16, 16]}>
        <Col xs={24} lg={16}>
          <Article />
        </Col>

        {checkRoleAccess([ROLE.ENGINEER, ROLE.ADMIN, ROLE.WORKER], roles) && (
          <Col xs={24} lg={8}>
            <ProjectsInfo />
          </Col>
        )}
      </Row>
    </div>
  );
}
